import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

// Import helpers
import {
	PRODUCT_TYPES_MAPPED,
	checkProductSubtype,
	urlTranslationTypes,
	checkIsWithinTimePeriod
} from 'helpers';

// Import paths
import { APP_CORE_PATHS } from 'components/routes/paths';

// Import utilities
import { useProductLimits } from 'components/utilities';

// Import helpers
import { PRODUCT_LIMIT_TYPES, getRenderAsLink } from 'helpers';

const { VIEWS } = PRODUCT_LIMIT_TYPES;
const { series, movie } = urlTranslationTypes;

const usePlayButton = ({ uuid, product }) => {
	const { t } = useTranslation();
	const { type: productType } = useParams();

	const {
		is_available: isAvailable,
		since,
		is_audio: isAudio,
		till,
		uuid: productUuid
	} = product;

	const { isLimitExceeded, limitMessage, limitCounter } = useProductLimits({
		product,
		limitType: VIEWS
	});

	const { isSeries } = checkProductSubtype(PRODUCT_TYPES_MAPPED[productType]);

	const type = isSeries ? series : movie;

	const linkRedirect = `${APP_CORE_PATHS.WATCH}/${type}/${uuid || productUuid}`;

	const translationKey = isAudio ? 'vod_buttons_listen' : 'vod_buttons_play';

	const buttonText = isLimitExceeded
		? limitMessage
		: `${t(translationKey)}${limitCounter}`;

	const isWithinTimePeriod = checkIsWithinTimePeriod({ since, till });

	const isAvailableToPlay =
		!isLimitExceeded && (isWithinTimePeriod || isAvailable);

	const opacity = isAvailableToPlay ? 1 : 0.8;

	const renderAs = getRenderAsLink(isAvailableToPlay);

	return {
		linkRedirect,
		buttonText,
		isAvailableToPlay,
		opacity,
		renderAs
	};
};

export default usePlayButton;
